import React from 'react'

import Link from 'next/link'

import Banner from '@/components/common/Banner'

import { DEMO_URL } from '@/constants/general'

interface FreeTrialBanner {
  daysRemaining: number
}

const FreeTrialBanner: React.FC<FreeTrialBanner> = ({ daysRemaining }) => {
  const dayLabel = daysRemaining === 1 ? 'day' : 'days'

  if (daysRemaining === 0) {
    return (
      <div className="flex items-center justify-center w-full py-2 bg-accent-400 text-sm font-bold text-white">
        <span className="hidden md:flex">
          Your organization&apos;s free trial has expired.&nbsp;
        </span>
        <span className="md:hidden">Free trial has expired.&nbsp;</span>
      </div>
    )
  }
  if (daysRemaining === 1) {
    return (
      <div className="flex items-center justify-center w-full py-2 bg-accent-400 text-sm font-bold text-white line-clamp-1">
        <span className="hidden md:flex">
          Your organization&apos;s free trial expires today.&nbsp;
        </span>
        <span className="md:hidden">Free trial expires today.&nbsp;</span>
      </div>
    )
  }
  return (
    <Banner>
      <span className="hidden md:flex">
        <span>
          Your organization&apos;s free trial has {daysRemaining} {dayLabel}{' '}
          remaining.&nbsp;
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={DEMO_URL}
            className="underline"
          >
            Book a demo here
          </Link>
          .
        </span>
      </span>
      <span className="md:hidden">
        <span>
          Free trial: {daysRemaining} {dayLabel} remaining.&nbsp;
        </span>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={DEMO_URL}
          className="underline"
        >
          Book a demo
        </Link>
        .
      </span>
    </Banner>
  )
}

export default FreeTrialBanner
